<template>
  <div class="focus-keywords">
    <div class="row search-input-content">
      <header-search-input
        :showArrow="false"
        class="search-input"
        :keyword="searchText"
        @searchCompany="onSearch"
        @onSuggestionItemClick="onSuggestionItemClick"
      ></header-search-input>
    </div>
    <div class="row focus-keywords-content">
      <div class="focus-keywords-content-left">
        <div class="focus-keywords-content-left-table">
          <div class="body">
            <el-table
              :data="personData"
            > 
              <el-table-column
                label="人物名称"
                >
                <template slot="header" slot-scope="scope">
                  <div @onScope="scope">
                    <div class="header-title">人物名称</div>
                  </div>
                </template>
                <template slot-scope="scope">
                  <router-link
                    class="title-name"
                    :to="{name: 'person', query: {q: scope.row.person}}"
                  >
                    {{scope.row.person}}
                  </router-link>
                </template>
              </el-table-column>
              <el-table-column width="76px" label="操作">
                <template slot="header" slot-scope="scope">
                  <div @onScope="scope">
                    <div class="header-title">操作</div>
                  </div>
                </template>
                <template slot-scope="scope">
                  <div class="operation-class">
                    <el-tooltip 
                      class="item" 
                      effect="dark" 
                      content="取消关注" 
                      :visible-arrow="false"
                      :enterable="false"
                      popper-class="tip"
                      placement="bottom-start"
                    >
                      <i class="delete" @click="onDeleteBtnClick(scope.row)"></i>
                    </el-tooltip>
                </div>
              </template>
            </el-table-column>
            </el-table>
          </div>
          <div class="pager" v-if="totalCount > pageSize">
            <el-pagination
              background
              @current-change="handleCurrentChange"
              :current-page.sync="pageNum"
              :page-size="pageSize"
              layout="prev, pager, next, jumper"
              :total="totalCount">
              </el-pagination>
          </div>
        </div>
      </div>
    </div>

    <el-dialog
      title='取消关注'
      class="delete-dialog"
      :visible.sync="dialogVisible"
      width="400px"
      top="30vh"
    >
    <div class="content">取消关注“{{ person }}”？</div>
      <div class="footer" slot="footer" >
        <div class="footer-btn">
          <el-button class="cancel-btn" @click="onCancelClick">取消</el-button>
          <el-button class="confirm-btn" @click="onOKDeleteBtnClick">确定</el-button>
        </div>
      </div>
    </el-dialog>
  </div>  
</template>

<script>
import QuestionQuery from '@/rest/questionQuery';
import authService from '@/services/authService';
import HeaderSearchInput from '@/components/common/FocusPersonInput';

export default {
  data() {
    return {
      person: '',
      personName: '',
      pageNum: 1,
      pageSize: 20,
      totalCount: 0,
      personId: -1,
      personData: [],
      username: '',
      dialogVisible: false,
      searchText: ''
    };
  },
  methods: {
    onSearch() {
      this.searchTermsRecommend();
    },
    onSuggestionItemClick({ name }) {
      this.personName = name;
      this.onAddPerson();
    },
    onAddPerson() {
      QuestionQuery.addMonitorPerson(this.username, this.personName).then(() => {
        this.personName = '';
        this.getMonitorPersonList();
      });
    },
    handleCurrentChange(res) {
      this.pageNum = res;
      this.getMonitorPersonList();
    },
    getMonitorPersonList() {
      const params = {
        user: this.username,
        page_num: this.pageNum,
        page_size: this.pageSize
      };
      QuestionQuery.getMonitorPersonList(params).then(res => {
        this.personData = res.page_items;
        this.totalCount = res.total_count;
      });
    },
    onDeleteBtnClick(res) {
      this.dialogVisible = true;
      this.person = res.person;
      this.personId = res.id;
    },
    onCancelClick() {
      this.dialogVisible = false;
    },
    onOKDeleteBtnClick() {
      QuestionQuery.deleteMonitorPerson(this.personId).then(() => {
        this.pageNum = 1;
        this.dialogVisible = false;
        this.getMonitorPersonList();
      });
    }
  },
  components: {
    HeaderSearchInput
  },
  mounted() {
    this.username = authService.getLoggedUserName();
    this.getMonitorPersonList();
  }
};
</script>

<style lang="scss" scoped>

  .focus-keywords {
    .search-input-content {
      height: 34px;
      padding: 24px;
      margin-bottom: 16px;
      .batch-add-btn {
        margin-top: -1px;
        margin-left: 10px;
        height: 26px;
        width: 80px;
        padding: 0;
        border-radius: 2px;
        border: none;
        font-size: 14px;
        color: #464d6c;
        background-color: #f7f8fc;
        font-weight: 400;
        &:hover {
          color: #464d6c;
          background-color: #eaebef;
        }
        &:focus {
          color: #464d6c;
          background-color: #eaebef;
        }
        &:active {
          color: #464d6c;
          background-color: #eaebef;
        }
      }
    }
    &-content {
      &-left {
        width: 1200px;
        min-height: calc(100vh - 134px);
        &-table {
          padding:10px 24px 0;
          .concern-btn {
            height: 26px;
            width: 122px;
            margin: 16px 0;
            padding: 0;
            border-radius: 2px;
            border: none;
            font-size: 14px;
            color: #464d6c;
            background-color: #f7f8fc;
            font-weight: 400;
            &:hover {
              color: #464d6c;
              background-color: #eaebef;
            }
            &:focus {
              color: #464d6c;
              background-color: #eaebef;
            }
            &:active {
              color: #464d6c;
              background-color: #eaebef;
            }
          }
          .body {
            min-height: calc(100vh - 225px);
          }
        }
      } 
      &-right {
        width: 595px;
        height: calc(100vh - 134px);
        background-color: #ffffff;
      }
      .add-btn {
        margin-top: 9px;
        height: 26px;
        width: 143px;
        padding: 0;
        border-radius: 2px;
        border: none;
        font-size: 14px;
        color: #464d6c;
        background-color: #f7f8fc;
        &:hover {
          color: #464d6c;
          background-color: #f7f8fc;
        }
        &:focus {
          color: #464d6c;
          background-color: #f7f8fc;
        }
        &:active {
          color: #464d6c;
          background-color: #f7f8fc;
        }
      }
    }
  }
  .title-name {
    color: #464d6c;
    font-size: 14px;
    text-decoration: none;
    cursor: pointer;
    &:hover {
      text-decoration: underline;
    }
  }
  .header-title {
    color: #747990;
    font-weight: 400;
  }
  .operation-class {
    display: flex;
    justify-content: space-around;
    .delete {
      display: inline-block;
      width: 16px;
      height: 16px;
      margin-right: 25px;
      background-color: transparent;
      background-image: url("../../assets/img/delete-icon.svg");
      background-size: 100% 100%;
      cursor: pointer;
      &:hover {
        border-radius: 2px;
        background-image: url("../../assets/img/delete-icon-hover.svg");
      }
    }
  }
  
  /deep/ {
    .el-table td,
    .el-table th.is-leaf {
      border-bottom: 1px solid #f7f7fa;
    }
    .el-table th.is-leaf {
      border-bottom: 1px solid #f7f7fa;
    }
    .el-table--enable-row-hover .el-table__body tr:hover > td {
      background-color: #f7f8fc !important;
    }
    .el-table::before {
      background-color: #f7f7fa;
    }
    .delete-dialog {
      .el-dialog {
        background-color: #ffffff;
        border-radius: 0;
        width: 400px;
        height: 229px;
        position: relative;
        .el-dialog__headerbtn {
          top: 14px;
        }
        .el-dialog__header {
          padding: 0;
          height: 44px;
          width: 100%;
          box-shadow: inset 0px -1px 0px 0px #f7f7fa;
          padding: 0 24px;
          .el-dialog__title {
            color: #171f46;
            font-size: 14px;
            line-height: 44px;
          }
        }
        .el-dialog__body {
          padding: 24px;
          margin-top: 44px;
          color: #747990;
          font-size: 14px;
          line-height: 22px;
        }
        .el-dialog__footer {
          width: 100%;
          height: 64px;
          background-color: #ffffff;
          box-shadow: inset 0px 1px 0px 0px #f7f7fa;
          position: absolute;
          bottom: 0;
          left: 0;
          padding: 16px 0;
          .footer-btn {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            width: 136px;
            height: 32px;
            .cancel-btn {
              height: 32px;
              width: 60px;
              padding: 0;
              font-size: 14px;
              color: #464d6c;
              background-color: #f7f8fc;
              border-radius: 2px;
              border: none;
              &:hover {
                color: #464d6c;
                background-color: #eaebef;
              }
              &:focus {
                color: #464d6c;
                background-color: #eaebef;
              }
              &:active {
                color: #464d6c;
                background-color: #eaebef;
              }
            }
            .confirm-btn {
              height: 32px;
              width: 60px;
              padding: 0;
              font-size: 14px;
              color: #ffffff;
              background-color: #45a8cc;
              margin-left: 16px;
              border-radius: 2px;
              border: none;
              &:hover {
                color: #ffffff;
                background-color: #3e97b8;
              }
              &:focus {
                color: #ffffff;
                background-color: #3e97b8;
              }
              &:active {
                color: #ffffff;
                background-color: #3e97b8;
              }
            }
          }
        }
      }
    }
  }
  .pager {
    display: flex;
    justify-content: center;
    height: 46px;
    margin-top: 26px;
    & /deep/ {
      .el-pagination{
        .btn-prev,
        .btn-next,
        .el-pager .number,
        .el-pager li.btn-quicknext,
        .el-pager li.btn-quickprev,
        .el-icon-more .el-icon-d-arrow-right{
          border-radius:2px;
          border:1px solid rgba(229,230,238,1);
          background: #ffffff;
          min-width: 22px !important;
          height: 22px;
          line-height: 22px;
          font-size: 12px;
        }
        .active{
          border: none;
        }
        .more::before {
          line-height: 22px;
        }
        .el-pagination__jump{
          color: #747990;
          line-height: 22px;
        }
      }
      .el-pagination__editor.el-input .el-input__inner {
        height: 22px;
      }
    }
  }
</style>
